import { Input, InputProps } from 'antd';

export type InputFormProps = InputProps;

const InputForm = Input;

export default InputForm;
